import React from 'react';
import { Box, Grid, Typography } from '@blueprint/ui';
import { useTranslation } from 'react-i18next';
import DefaultTable from '../Table/DefaultTable';

const MultipleSelectionAck = ({
    tableData,
    columns,
    showPaypalEmail,
    paypalEmail,
    fxRate,
    showFxRate,
    payoutAmount,
    payoutCurrency,
    showBankDetails,
    bankDisplayValue,
    showTotalPayerAmount,
    payerCurrency,
    totalPayerAmount,
}) => {
    const { t } = useTranslation();

    const referencesArray = tableData.map((transaction) => {
        const reference = transaction.custBeneInfo;
        return reference;
    });
    console.log('References Array ', referencesArray);

    const referencesString = referencesArray.toString();
    console.log('References String', referencesString);
    return (
        <Grid container component='dl'>
            <Grid container>
                <Grid item xs={6} sm={4} component='dt'>
                    <Box marginTop={2}>
                        <Typography variant='body1'>{t('acknowledgementPage.paymentReferences')}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={6} component='dd'>
                    <Box marginTop={2} marginLeft='20px'>
                        <Typography variant='body1' id='ack-typo-references'>
                            {referencesString}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

            {showPaypalEmail ? (
                <Grid container>
                    <Grid item xs={6} md={4} component='dt'>
                        <Box marginBottom={2}>
                            <Typography variant='body1'>{t('acknowledgementPage.paypal_Account_details')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginLeft='20px'>
                            <Typography variant='body1' id='ack-typo-fxRate'>
                                {paypalEmail}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}

            {showTotalPayerAmount ? (
                <Grid container>
                    <Grid item xs={6} md={4} component='dt'>
                        <Box marginBottom={2}>
                            <Typography variant='body1'>{t('acknowledgementPage.totalPaymentAmount')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginLeft='20px'>
                            <Typography variant='body1' id='ack-typo-fxRate'>
                                {payerCurrency} &nbsp; {totalPayerAmount}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}

            {showFxRate ? (
                <Grid container>
                    <Grid item xs={6} md={4} component='dt'>
                        <Box marginBottom={2}>
                            <Typography variant='body1'>{t('acknowledgementPage.rate_used')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginLeft='20px'>
                            <Typography variant='body1' id='ack-typo-fxRate'>
                                {fxRate}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}

            <Grid container>
                <Grid item xs={6} md={4} component='dt'>
                    <Box marginBottom={2}>
                        <Typography variant='body1'>{t('acknowledgementPage.payment_amount')}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={6} component='dd'>
                    <Box marginLeft='20px'>
                        <Typography variant='body1' id='ack-typo-fxRate'>
                            {payoutCurrency} &nbsp;{payoutAmount}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
            {showBankDetails ? (
                <Grid container>
                    <Grid item xs={6} md={4} component='dt'>
                        <Box marginBottom={2}>
                            <Typography variant='body1'>{t('acknowledgementPage.bank_Account_details')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginLeft='20px'>
                            <Typography variant='body1' id='ack-typo-fxRate'>
                                {bankDisplayValue}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}
        </Grid>
    );
};

export default MultipleSelectionAck;
